import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {ApiService} from '@app/shared/services/api.service';


@Injectable({
  providedIn: 'root'
})

export class ReportService {

  constructor(private api: ApiService) {
  }

  listStockValueReport(opData: any): Observable<any> {
    return this.api.post('Report/listStockValueReport', opData)
  }

  listWarehouseReport(opData: any): Observable<any> {
    return this.api.post('Report/listWarehouseReport', opData)
  }

  saveWarehouse_move_data(opData: any): Observable<any> {
    return this.api.post('Report/savemovewarehouseDetails', opData)
  }

  listWarehousepurchaseReport(opData: any): Observable<any> {
    return this.api.post('Report/listWarehousepurchaseReport', opData)
  }

  listPurchaseReport(opData: any): Observable<any> {
    return this.api.post('Report/listPurchaseReport', opData)
  }

  listWarehouse(opData: any): Observable<any> {
    return this.api.post('Warehouse/listWarehouse', opData)
  }

  listSaleReport(opData: any): Observable<any> {
    return this.api.post('Report/listSaleReport', opData)
  }

  WarehouseStockLog(opData: any): Observable<any> {
    return this.api.post('Report/WarehouseStockLog', opData)
  }

  detailedlist(opData: any): Observable<any> {
    return this.api.post('Sale/detailedlist', opData)
  }

  saveSale(opData: any): Observable<any> {
    return this.api.post('Sale/saveSale', opData)
  }

  saveReturnSale(opData: any): Observable<any> {
    return this.api.post('SaleReturn/saveReturnSale', opData)
  }

  sendToMail(opData: any): Observable<any> {
    return this.api.post('Sale/sendToMail', opData)
  }

  SaleFinalize(opData: any): Observable<any> {
    return this.api.post('Sale/SaleFinalize', opData)
  }

  CancelInvoice(opData: any): Observable<any> {
    return this.api.post('Sale/CancelInvoice', opData)
  }

  getSale(opData: any): Observable<any> {
    return this.api.post('Sale/getSale', opData)
  }

  getSaleforReturn(opData: any): Observable<any> {
    return this.api.post('SaleReturn/getSale', opData)
  }

  Updatesale(opData: any): Observable<any> {
    return this.api.post('Sale/Updatesale', opData)
  }

  getVatValue(opData: any): Observable<any> {
    return this.api.post('Sale/getVatValue', opData)
  }

  listState(): Observable<any> {
    return this.api.post('Sale/listState')
  }

  listCustomer(): Observable<any> {
    return this.api.post('Sale/listCustomer')
  }

  getReturnSale(opData: any): Observable<any> {
    return this.api.post('SaleReturn/getReturnSale', opData)
  }

  listSale(opData: any): Observable<any> {
    return this.api.post('Sale/listSale', opData)
  }

  listReturnSale(opData: any): Observable<any> {
    return this.api.post('SaleReturn/listReturnSale', opData)
  }

  listCustomerInvoice(opData: any): Observable<any> {
    return this.api.post('SaleReturn/listCustomerInvoice', opData)
  }

  purchaseItemDetails(opData: any): Observable<any> {
    return this.api.post('Report/purchaseItemDetails', opData)
  }

  purchaseReturnItemDetails(opData: any): Observable<any> {
    return this.api.post('Report/purchaseReturnItemDetails', opData)
  }

  salesItemDetails(opData: any): Observable<any> {
    return this.api.post('Report/salesItemDetails', opData)
  }

  salesReturnItemDetails(opData: any): Observable<any> {
    return this.api.post('Report/salesReturnItemDetails', opData)
  }

  DamagedItemDetails(opData: any): Observable<any> {
    return this.api.post('Report/DamagedItemDetails', opData)
  }

  StockItemDetails(opData: any): Observable<any> {
    return this.api.post('Report/StockItemDetails', opData)
  }

  checkCreditNote(opData: any): Observable<any> {
    return this.api.post('CreditNote/checkCreditNote', opData)
  }

}
